import styled, { keyframes } from "styled-components";

import brk from "../../util/breakpoints";

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(184, 242, 61, 0.5); }
  70% { box-shadow: 0 0 0 7px rgba(184, 242, 61, 0); }
  100% { box-shadow: 0 0 0 0 rgba(184, 242, 61, 0); }
`;

export const Wrapper = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 400;
  background: ${(props) => (props.$scrolled ? "rgba(8, 10, 16, 0.82)" : "transparent")};
  backdrop-filter: ${(props) => (props.$scrolled ? "blur(12px)" : "none")};
  transition: background 0.3s;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  height: var(--navHeight);
  border-bottom: 1px solid var(--border);
  @media ${brk.device.tablet} {
    grid-template-columns: auto 1fr;
  }
`;

export const Identity = styled.a`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-self: start;
  text-decoration: none;
`;

export const Monogram = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: var(--lime);
  color: var(--ink);
  font-family: var(--fontHeading);
  font-size: 15px;
  font-weight: 700;
`;

export const Nameplate = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  white-space: nowrap;
  @media ${brk.device.tablet} {
    display: none;
  }
`;

export const Name = styled.p`
  color: var(--text);
  font-family: var(--fontHeading);
  font-size: 16px;
`;

export const Role = styled.p`
  color: var(--textDim);
  font-family: var(--fontMono);
  font-size: 9px;
  text-transform: uppercase;
`;

export const NavLinkBox = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  @media ${brk.device.tablet} {
    justify-self: end;
    gap: 20px;
  }
`;

export const NavLink = styled.a`
  position: relative;
  padding: 10px 0;
  color: ${(props) => (props.$active ? "var(--text)" : "var(--textMuted)")};
  font-family: var(--fontBody);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  text-decoration: none;
  user-select: none;
  transition: color 0.25s;
  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    width: ${(props) => (props.$active ? "18px" : "0px")};
    height: 2px;
    border-radius: 2px;
    background: var(--lime);
    transform: translateX(-50%);
    transition: width 0.25s;
  }
  &:hover {
    color: var(--text);
  }
`;

export const Availability = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-self: end;
  color: var(--textMuted);
  font-family: var(--fontMono);
  font-size: 10px;
  text-transform: uppercase;
  white-space: nowrap;
  @media ${brk.device.tablet} {
    display: none;
  }
`;

export const AvailabilitySignal = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--lime);
  animation: ${pulse} 2.4s infinite;
`;
